import { Checkbox, Field, RadioGroup } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { isNil, pipe } from 'ramda';
import { useSelector } from 'react-redux';
import { MeasurementCalculationSection } from './MeasurementCalculationSection';

let MeasurementsSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const resultNotObtainable = useSelector(
    pipe(createWorksheetSelector!('Measurements.ResultNotObtainable'), valueOrDefault(false))
  );
  const unableToPenetrateFurther = useSelector(
    pipe(createWorksheetSelector!('Measurements.UnableToPenetrateFurther'), valueOrDefault(false))
  );
  const resultNotObtainableDisabled = useSelector(
    pipe(createWorksheetSelector!('Measurements.Measurements'), (m) =>
      m.slice(1).some((x: any) => !isNil(x.DepthReading))
    )
  );
  const bulkAddRowsVisible = useSelector(
    pipe(createWorksheetSelector!('Results.LayerBoundaries'), (b) => b?.length <= 1)
  );

  return (
    <NamePrefixModifier appendNamePrefix="Measurements">
      <ListFieldSection>
        <FieldSet>
          <Field disabled={resultNotObtainableDisabled} input={<Checkbox />} name="ResultNotObtainable" />
          <Field
            input={<RadioGroup />}
            options={[{ label: 'Material not suitable', value: 'Material not suitable' }]}
            freeEntry={true}
            freeEntryLabel="Other"
            defaultValue="Material not suitable"
            name="ResultNotObtainableReason"
            visible={resultNotObtainable}
          />
        </FieldSet>
      </ListFieldSection>

      <MeasurementCalculationSection
        disabled={unableToPenetrateFurther}
        visible={!resultNotObtainable}
        bulkAddRowsVisible={bulkAddRowsVisible}
      >
        <ListFieldSection single>
          <Field disabled={!resultNotObtainableDisabled} input={<Checkbox />} name="UnableToPenetrateFurther" />
        </ListFieldSection>
      </MeasurementCalculationSection>
    </NamePrefixModifier>
  );
};

const MeasurementsSection = withInjectedProps(MeasurementsSectionBase);
export { MeasurementsSection };
export default MeasurementsSection;
